import React from 'react'
import TextField from '../../Reusable/Form/TextInput'

const PaymentMethodForm = ({ register, errors, setValue, getValues, clearErrors }: any) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
    </div>
  )
}

export default PaymentMethodForm
